import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.permission, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: payload.permissions,
        totalCount: payload.totalCount,
      };
    case types.SET_PERMISSION_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };
    case types.DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        permissions: state.permissions.filter(({ id }) => id !== payload.id),
        totalCount: state.totalCount - 1,
      };
    default:
      return state;
  }
}
